import Signup from '../components/SignUp/SignUp';

const SignupPage = () => {
  return <Signup />;
};

export default SignupPage;
